import { readonly, ref, type Ref } from 'vue';

// Single app-wide "mobile" definition, aligned with Tailwind's `md` breakpoint
// (768px): below it, views render their trimmed-down phone layouts. Keep this
// in sync with the `@media (max-width: 767.98px)` rules in component styles.
const MOBILE_MEDIA_QUERY = '(max-width: 767.98px)';

const isMobile = ref(false);

// Guarded for non-browser environments (jsdom in unit tests).
if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  const query = window.matchMedia(MOBILE_MEDIA_QUERY);
  isMobile.value = query.matches;
  query.addEventListener('change', (event) => {
    isMobile.value = event.matches;
  });
}

/**
 * Reactive flag for phone-sized viewports. Module-level singleton: one media
 * query listener shared by every consumer.
 */
export function useIsMobile(): Readonly<Ref<boolean>> {
  return readonly(isMobile);
}
